import { EntityLegalType } from './../../models/entity';
import { BaseHttpService } from './base.http.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';


@Injectable()
export class UtilitiesService extends BaseHttpService {
  constructor(private http: HttpClient, private appConfig: AppConfig) {
    super();
  }

  get envSettings(): IEnvironmentConfig {
    return this.appConfig.getEnvironmentConfig();
  }

  public loadCountries(): Observable<any> {
    const url = `${this.envSettings.webApiUrl}admin/country`;
    return this.http.get(url, {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }


  public loadTaxRateSchedule(v: EntityLegalType): Observable<any> {
    const entityLegalType = v;
    const url = `${this.envSettings.webApiUrl}taxrateschedules?entityLegalType=${entityLegalType}`;
    return this.http.get(url, {
      observe: 'body',
      responseType: 'json',
      headers: this.getHttpHeaders()
    });
  }

  public genRandomString(length) {
    var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
    var charLength = chars.length;
    var result = '';
    for (var i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
  }

  public base64URL(buffer: ArrayBuffer): string {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  }

  public async sha256(verifier: string): Promise<ArrayBuffer> {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    return window.crypto.subtle.digest('SHA-256', data);
  }
}
